export default __webpack_public_path__ + "static/cross-platform-3cf5e66625dddc3820603ac191d0b2b3.png";